import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CollectionCardPlaceholder = () => {
  return (
    <>
      <div className="collections space-y-10 mb-30">
        <div className="collections_item">
          <div>
            <div className="row">
              <div className="col-sm-12 col-lg-4">
                <Skeleton
                  height={"5rem"}
                  style={{ borderRadius: "18px" }}
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <Skeleton
                  height={"5rem"}
                  style={{ borderRadius: "18px" }}
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <Skeleton
                  height={"5rem"}
                  style={{ borderRadius: "18px" }}
                />
              </div>
            </div>
            <Skeleton
              height={320}
              width="100%"
              style={{ borderRadius: "18px", marginTop: "1.2rem" }}
            />
          </div>

          <div className="pt-3">
            <div className="row" style={{ margin: "0.6px" }}>
              <div className="col-lg-8">
                <Skeleton height={"2rem"}  />
              </div>
              <div className="col-lg-4">
                <Skeleton height={"2rem"}  />
              </div>
            </div>
            <Skeleton height={"2rem"} style={{ margin: "0.6px" }} width="80%" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CollectionCardPlaceholder;
